import {isTablet, isTabletPortrait} from '../base/common';
import Parallax from 'parallax-js';


export default class SimpleEvents {
    constructor() {
        this.isTablet = window.innerWidth < 1024;
        this.isTabletPortrait = window.innerWidth < 1024 && window.innerWidth < window.innerHeight;

        this.scrollDown();
        this.animateCircle();
        this.backgroundAnimation();
    }

    elementInViewport(el) {
        let top = el.offsetTop;
        let height = el.offsetHeight;

        return (
            top >= window.pageYOffset &&
            (top + height) <= (window.pageYOffset + window.innerHeight)
        );
    }

    scrollDown() {
        const $scrollLink = document.querySelector('.js-scroll-down');

        if ($scrollLink) {
            $scrollLink.addEventListener('click', (e) => {
                e.preventDefault();

                const $target = document.querySelector($scrollLink.getAttribute('href'));
                const hasSmoothScroll = 'scrollBehavior' in document.documentElement.style;

                if (hasSmoothScroll) {
                    $target.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
                } else {
                    $target.scrollIntoView(false);
                }
            });

        }
    }

    animateCircle() {
        const element = document.querySelector('.block--with-dot');

        window.addEventListener('scroll',  () => {
            if (this.elementInViewport(element) && !this.isTabletPortrait) {
                element.classList.add('animate');
            }
        });
    }

    backgroundAnimation() {
        const bg = document.getElementById('animate_bg');
        const bg2 = document.getElementById('animate_bg_top');

        console.log(this.isTablet);

        if (this.isTablet) return;

        console.log(bg, bg2);
        if (bg) {
            const parallax = new Parallax(bg, {
                relativeInput: true,
            });
        }
        if (bg2) {
            const parallax2 = new Parallax(bg2, {
                relativeInput: true,
            });
        }
    }
}


// WEBPACK FOOTER //
// ./sources/js/events/simpleEvents.js